// extracted by mini-css-extract-plugin
module.exports = {"borders":"Checkbox_borders__1BntO","checkbox":"Checkbox_checkbox__3LimK","container":"Checkbox_container__3RAHr"};